<template>
  <section class="section-hero section-shaped my-0">
    <div class="shape shape-style-1 shape-primary">
      <span class="span-150"></span>
      <span class="span-50"></span>
      <span class="span-50"></span>
      <span class="span-75"></span>
      <span class="span-100"></span>
      <span class="span-75"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
    </div>
    <div class="container shape-container d-flex align-items-center">
      <div class="col px-0">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-8 text-center pt-lg">
            <h3 class="text-white mt-4 mb-5">Welcome to APES Family</h3>
            <p class="text-white mb-5">
              5555 Unique Algorithmically generated Thug Apes NFTs awaits.
            </p>
            <div class="btn-wrapper">
              <base-button
                tag="a"
                href="https://mint.thugape.com"
                class="mb-3 mb-sm-0"
                type="white"
                icon="fas fa-candy-cane"
                >Mint Now
              </base-button>
            </div>
          </div>
          <div class="col-lg-4 text-center pt-lg">
            <img src="img/mint.gif" style="width: 500px" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {};
</script>
<style>
</style>
